import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-alert-api',
  templateUrl: './dialog-alert-api.component.html',
  styleUrls: ['./dialog-alert-api.component.sass']
})
export class DialogAlertApiComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogAlertApiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close(true);
  }
}
